export default __webpack_public_path__ + "static/media/ic_cyprus.c068fd7d.svg";